// extracted by mini-css-extract-plugin
export default {"board":"boardContainer_board__IRAg4","line":"boardContainer_line__Ue2R3","column":"boardContainer_column__YstOG"};